import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '../../api/api';

@Injectable()
export class FeedbackProvider {
  
    constructor(public api: Api) { }

    add_feedback(params?:any){
        let seq = this.api.post('index.php/myradiant/Feedback/add', params);
        return seq;  
    }
}



// WEBPACK FOOTER //
// ./src/providers/myradiant/feedback/provider.ts